<template>
  <BittsTabs
    :current-value="currentTab"
    :tabs="tabs"
    :full-width="false"
    data-testid="irp-tab-bar"
    @change:tab="(tab) => emit('change:tab', tab)"
  >
    <template #labelSuffix="{ value }">
      <BittsCount
        v-if="counts[value]"
        :count="counts[value]"
        type="neutral"
        class="ml-4 mt-2"
      />
    </template>
  </BittsTabs>
</template>

<script setup lang="ts">
import { BittsCount, BittsTabs } from '@crossbeam/bitts';

import { computed } from 'vue';

import useAuth from '@/composables/useAuth';
import { useIndividualRecordStore } from '@/stores';

import { type IRPTabType, IRP_TABS, IRP_TAB_SCOPES, irpTabName } from './irp';

type Props = {
  currentTab: IRPTabType;
  counts?: Partial<Record<IRPTabType, number>>;
};

const { currentTab, counts = {} } = defineProps<Props>();

const emit = defineEmits<{
  'change:tab': [tab: IRPTabType];
}>();

const { hasScope } = useAuth();
const individualRecordStore = useIndividualRecordStore();

const tabs = computed(() =>
  IRP_TABS.filter(({ value }) => {
    const scope = IRP_TAB_SCOPES[value];
    return !scope || hasScope(scope);
  }).map((tab) => ({
    ...tab,
    name: irpTabName(tab.value, individualRecordStore.mdmType),
  })),
);
</script>

<style scoped lang="pcss">
@reference "../../../css/theme.css";
.bitts-simple-tabs {
  @apply px-24 border-b-2 border-neutral-background-disabled;
}
</style>
